import { giphyLightCharcoal } from '@giphy/colors'
import {
    PauseIcon as PauseIconComponent,
    PlayIcon as PlayIconComponent,
    VolumeOffIcon,
    VolumeOnIcon,
} from '@giphy/react-components'
import { uniqueId } from 'lodash'
import { useRef } from 'react'

export type IconProps = {
    className?: string
}

export type GradientIconProps = {
    className?: string
    colors: string[]
}

const getFilterId = (): string => uniqueId('iconfilter')

export const AddMoreIcon = ({ className }: { className: string }) => <div className={`ss-plus ${className}`} />

export const GifIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" className={className}>
        <path
            d="M20 0a6 6 0 016 6v14a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6h14zM7.928 9C5.196 9 3.95 10.933 3.95 12.815S5.04 16.6 7.918 16.6c1.402 0 2.67-.494 3.127-1.409v-3.198H7.492v1.594h1.839v.925c-.416.299-1.018.37-1.403.37-1.464 0-1.952-1.141-1.952-2.067 0-1.409.768-2.108 1.952-2.108.489 0 1.133.134 1.662.628l1.195-1.173C9.829 9.206 8.936 9 7.928 9zm6.673.206h-2.047v7.199h2.047v-7.2zm7.399 0h-5.578v7.199h2.036v-2.479h3.324V12.26h-3.324v-1.347H22V9.206z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const StickerIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" className={className}>
        <path
            d="M12.384 0c6.15 0 11.25 4.338 12.216 10.022-1.322-.518-2.876-1.035-4.389-1.035-6.306 0-11.589 4.75-11.09 11.097.09 1.162.689 2.774 1.035 3.83C4.744 22.63 0 17.611 0 11.98 0 5.364 5.545 0 12.384 0zm11.233 11.44L11.92 23.012c-.504-1.082-.893-2.339-.893-3.603 0-2.898.97-4.821 2.564-6.303 1.382-1.284 3.084-2.185 5.632-2.4 1.555-.13 3.048.182 4.394.734z"
            fill="#FFF"
            fillRule="nonzero"
        />
    </svg>
)

export const VideoIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" className={className}>
        <path
            d="M18.48 0a6.72 6.72 0 016.72 6.72v11.76a6.72 6.72 0 01-6.72 6.72H6.72A6.72 6.72 0 010 18.48V6.72A6.72 6.72 0 016.72 0zm-5.043 7.321a.405.405 0 00-.573-.002l-2.58 2.56H6.705a.405.405 0 00-.405.405v4.77c0 .224.181.405.405.405h2.832l3.327 3.321a.405.405 0 00.69-.286V7.606a.405.405 0 00-.117-.285zm3.645 1.244a.608.608 0 00-.826.217.594.594 0 00.22.817 4.174 4.174 0 012.115 3.625 4.174 4.174 0 01-2.107 3.62.594.594 0 00-.219.818.608.608 0 00.827.216 5.367 5.367 0 002.708-4.654 5.368 5.368 0 00-2.718-4.66zm-1.656 1.571a.608.608 0 00-.805.284.595.595 0 00.286.796 1.792 1.792 0 011.037 1.621 1.79 1.79 0 01-.916 1.56.594.594 0 00-.225.815.608.608 0 00.825.222 2.982 2.982 0 001.525-2.597c0-1.165-.68-2.21-1.727-2.7z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const TextIcon = ({ className }: IconProps) => (
    <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 40 40">
        <path
            d="M19.68 8.16c6.54 0 11.84 5.3 11.84 11.84v11.84H19.68c-6.54 0-11.84-5.3-11.84-11.84s5.3-11.84 11.84-11.84zm4.474 8.48l-1.844.205v1.561h-1.126v1.536h1.126v2.381c0 1.971 1.037 2.573 2.407 2.509.499-.026.87-.102 1.331-.282l-.422-1.536c-.205.103-.55.154-.768.154-.346 0-.717-.18-.717-.845v-2.38h1.613v-1.537h-1.6V16.64zm-2.917-.992H13.8v1.78h2.726v7.18h1.984v-7.18h2.727v-1.78z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const SuperCutIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 32" className={className}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M34.1 11.5a2.1 2.1 0 00-2.1 2.1v2.8c0 1.16.94 2.1 2.1 2.1h16.8a2.1 2.1 0 002.1-2.1v-2.8a2.1 2.1 0 00-2.1-2.1H34.1zm7 1.4h2.8a.7.7 0 01.7.7v2.8a.7.7 0 01-.7.7h-2.8a.7.7 0 01-.7-.7v-2.8a.7.7 0 01.7-.7zm6.3 0h2.8a.7.7 0 01.7.7v2.8a.7.7 0 01-.7.7h-2.8a.7.7 0 01-.7-.7v-2.8a.7.7 0 01.7-.7zm-12.6 0h2.8a.7.7 0 01.7.7v2.8a.7.7 0 01-.7.7h-2.8a.7.7 0 01-.7-.7v-2.8a.7.7 0 01.7-.7z"
                fill="#FFF"
            />
            <path
                d="M3.9 11.59C1.235 9.353.686 5.62 2.674 3.25 4.662.881 8.434.774 11.1 3.01c2.665 2.237 3.214 5.97 1.226 8.34-1.988 2.369-5.76 2.476-8.426.24z"
                stroke="#FFF"
                strokeWidth="2.1"
            />
            <path
                fill="#FFF"
                d="M17.616 17.424l15.316 9.339H38.3L20.623 15.7zM8.579 17.85L33.991 2.017H38.3L11.626 19.35l-2.133-1.817z"
            />
            <path
                d="M3.9 19.81c-2.665 2.237-3.214 5.97-1.226 8.34 1.988 2.369 5.76 2.476 8.426.24 2.665-2.237 3.214-5.97 1.226-8.34-1.988-2.369-5.76-2.476-8.426-.24z"
                stroke="#FFF"
                strokeWidth="2.1"
            />
        </g>
    </svg>
)

export const EraseIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M195.34 55.325c1.79-.056 3.555.232 5.207.831 2.367.52 4.63 1.663 6.532 3.435l44.553 41.547c5.655 5.273 5.964 14.132.68 19.799l-71.11 75.028h63.756a4 4 0 01.213 7.995l-.213.006-71.229-.001-.137.165h-29.525a14.002 14.002 0 01-9.614-3.823l-40.682-38.43c-6.795-6.418-7.134-17.116-.76-23.952L165.306 60.4a14 14 0 019.804-4.446zm-44.847 44.418l-11.307.394-40.324 43.244a9 9 0 00.194 12.478l.208.203 40.683 38.43a6 6 0 004.12 1.638l2.582-.002a3.99 3.99 0 01.921-.157l.213-.005 9.83-.001-44.502-39.636c-4.459-3.97-4.924-10.755-1.074-15.326l.206-.238.14-.152 38.11-40.87zm7.185 4.026l-39.491 42.35a3.001 3.001 0 00.244 4.237l47.159 42.002a6.002 6.002 0 006.708.87l35.7-42.536-50.32-46.923z"
                fill="#E646B6"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const PaintIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M221.597 54.228c6.911-7.672 18.712-8.309 26.358-1.423.166.15.33.302.49.457 7.493 7.255 7.667 19.232.388 26.753l-.25.253-70.861 70.522.111.288-7.688 7.253-10.882 10.831a26.71 26.71 0 01-6.163 18.804l-.273.32c-9.573 11.047-22.494 18.895-35.693 22.57-12.342 3.437-23.447 2.768-28.356-2.496-2.94-3.153-3.92-6.263-1.558-9.233.76-.956 1.682-1.61 3.006-2.325l.505-.262 2.36-1.177.41-.21c5.089-2.66 8.224-5.833 10.396-12.048l1.2-3.41.93-2.603.872-2.399.662-1.78.633-1.664.607-1.555.442-1.099.288-.7.424-1.009.415-.957.409-.91.403-.864.266-.553.265-.534.396-.77.263-.493.264-.479.264-.463.264-.45.267-.438.268-.426.27-.415.273-.404.277-.395.28-.387.283-.379.434-.555.295-.363.301-.357.307-.354.472-.525.488-.52.334-.345.517-.519.356-.347.55-.524.473-.437c5.089-4.583 11.86-6.42 18.39-5.688zm-74.459 105.763c-5.854-6.3-16.293-6.926-22.409-1.204l-.3.284-.58.563-.416.42-.402.422-.389.427-.378.433-.246.295-.362.452-.237.309-.234.316-.345.49-.228.337-.226.348-.225.36-.335.56-.224.389-.223.403-.224.417-.225.433-.226.45-.342.705-.347.746-.354.79-.361.835-.371.885-.381.936-.527 1.333-.55 1.437-.579 1.546-.766 2.097-.99 2.772-.714 2.04c.76 3.008 2.762 4.79 6.005 5.343 5.037.86 7.558 4.406 7.561 10.637 7.73-3.781 14.953-9.183 20.75-15.9 5.823-6.749 6.026-17.052.4-23.106zm10.535-21.091l-9.826 10.373a5.752 5.752 0 00-.2.222l-.188.232c-.064.085-.127.17-.186.257a23.597 23.597 0 015.817 4.538 22.533 22.533 0 013.313 4.602 8.68 8.68 0 003.34-1.968l4.849-4.576 3.729-3.711-.037-.085c-1.351-3.053-2.696-5.288-3.976-6.69l-.191-.203-.174-.175c-1.252-1.227-3.316-2.192-6.235-2.808l-.035-.008zm84.915-80.136c-4.367-3.931-11.105-3.567-15.051.813l-65.125 72.298c2.913.95 5.3 2.306 7.142 4.11 1.711 1.676 3.296 3.967 4.794 6.887l68.67-68.343.272-.286c3.994-4.347 3.829-11.1-.423-15.218l-.28-.261z"
                fill="#0F9"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const LassoIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M122.308 188.824a23.465 23.465 0 007.986.911c-1.16 5.792-3.067 10.754-5.98 15.092-5.305 7.894-13.655 13.03-25.436 15.111a4 4 0 01-4.633-3.251 4.008 4.008 0 013.245-4.644c14.786-2.611 22-10.071 24.818-23.219zm6.629-39.134c9.112 0 16.5 7.403 16.5 16.534 0 9.132-7.388 16.535-16.5 16.535-9.113 0-16.5-7.403-16.5-16.535 0-9.131 7.387-16.534 16.5-16.534zM173 59c49.361 0 90 25.872 90 59.124s-40.639 59.124-90 59.124c-7.728 0-15.242-.635-22.42-1.832a23.52 23.52 0 001.848-9.849c6.553 1.081 13.447 1.66 20.572 1.66 44.527 0 80-22.583 80-49.103 0-26.52-35.473-49.103-80-49.103s-80 22.583-80 49.103c0 11.918 7.164 23.041 19.095 31.677a23.566 23.566 0 00-5.302 8.521C92.049 147.862 83 133.814 83 118.124 83 84.872 123.639 59 173 59z"
                fill="#93F"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const MagicWandIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M215.524 76.13l6.29 6.29c4.684 4.684 4.68 12.281-.007 16.969L121.72 199.474c-4.688 4.688-12.285 4.691-16.968.008l-6.29-6.29c-4.684-4.684-4.68-12.281.007-16.969L198.556 76.138c4.687-4.688 12.284-4.691 16.968-.008zm-36.998 31.344l-74.402 74.403a4 4 0 00-.003 5.656l6.29 6.29a4 4 0 005.656-.002l74.397-74.398-11.938-11.949zm74.487-6.458c.221 23.277 12.238 23.985 12.959 24.006h.034c-12.993 0-12.993 24.008-13.012 24.008l-.003-.713c-.255-23.294-12.971-23.294-12.971-23.294 12.603 0 12.981-22.588 12.992-23.944zm-2.999-79.024c.293 28.416 16.33 28.997 16.971 29.008h.02c-16.99 0-16.99 29.01-17.015 29.01 0-28.43-16.294-28.998-16.946-29.01h-.02c16.65 0 16.984-27.86 16.99-28.974zm-82.954 4.026l.01.599c.463 19.962 12.483 20.374 12.968 20.382h.015c-12.993 0-12.993 21.007-13.011 21.007 0-20.586-12.46-20.998-12.96-21.006h-.015c12.603 0 12.982-19.765 12.993-20.951v-.031z"
                fill="#0CF"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const NewIcon = ({ className }: IconProps) => (
    <svg
        width="48"
        height="30"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={className}
    >
        <defs>
            <filter
                x="-22.4%"
                y="-32.5%"
                width="144.7%"
                height="185%"
                filterUnits="objectBoundingBox"
                id="newiconshadow"
            >
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" in="shadowBlurOuter1" />
            </filter>
            <path
                d="M36 0a2 2 0 012 2v16a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h34zM18.946 8.072c-.576 0-.576 0-1.086.204-.51.204-.51.204-.894.588s-.384.384-.606.948c-.222.564-.222.564-.222 1.296 0 .78 0 .78.228 1.344.228.564.228.564.618.942s.39.378.906.558c.516.18.516.18 1.092.18.876 0 .876 0 1.524-.306.567-.268.567-.268 1.015-.88l.125-.182-1.164-.708c-.36.504-.36.504-.696.654-.336.15-.336.15-.756.15-.48 0-.48 0-.87-.324-.341-.284-.341-.284-.43-.88l-.02-.176h3.948c-.024-1.716-.024-1.716-.762-2.562-.738-.846-.738-.846-1.95-.846zM9.958 5.996H8.302V14h1.596V8.708L13.378 14h1.416V5.996h-1.596v4.992l-3.24-4.992zm13.692 2.22h-1.632L24.082 14h1.14l1.092-3.348L27.418 14h1.14l2.064-5.784H28.99l-1.044 3.48-1.152-3.48h-.96l-1.14 3.48-1.044-3.48zM18.946 9.26c.384 0 .384 0 .726.288.342.288.342.288.39.864h-2.316c.036-.264.036-.264.15-.48.114-.216.114-.216.282-.366.168-.15.168-.15.366-.228.198-.078.198-.078.402-.078z"
                id="newiconpath"
            />
        </defs>
        <g transform="translate(5 3)" fill="none" fillRule="evenodd">
            <use fill="#000" filter="url(#newiconshadow)" xlinkHref="#newiconpath" />
            <use fill="#FFF" xlinkHref="#newiconpath" />
        </g>
    </svg>
)

export const CheckIcon = ({ className }: IconProps) => (
    <div className={className} style={{ height: 16, width: 16 }}>
        <svg
            width="40"
            height="40"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{ height: 40, width: 40, margin: '-10px -12px -14px' }}
        >
            <defs>
                <filter
                    x="-118.8%"
                    y="-106.2%"
                    width="337.5%"
                    height="337.5%"
                    filterUnits="objectBoundingBox"
                    id="checkiconshadow"
                >
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter1" />
                </filter>
                <path
                    d="M430 279a8 8 0 110 16 8 8 0 010-16zm3.33 4a.19.19 0 00-.15.067l-4.429 5.049-1.931-2.208a.19.19 0 00-.15-.067.19.19 0 00-.148.067l-1.459 1.659a.235.235 0 00-.063.169c0 .068.021.125.063.17l3.537 4.027c.055.045.106.067.151.067.046 0 .096-.022.151-.067l6.035-6.869a.235.235 0 00.063-.17.235.235 0 00-.063-.168l-1.459-1.66a.19.19 0 00-.149-.066z"
                    id="checkiconpath"
                />
            </defs>
            <g transform="translate(-410 -269)" fill="none" fillRule="evenodd">
                <use fill="#000" filter="url(#checkiconshadow)" xlinkHref="#checkiconpath" />
                <use fill="#FFF" xlinkHref="#checkiconpath" />
            </g>
        </svg>
    </div>
)

export const BackArrowIcon = ({ className }: IconProps) => (
    <svg className={className} width="30" height="30" xmlns="http://www.w3.org/2000/svg">
        <g fill="#FFF" fillRule="nonzero">
            <path d="M18.758 25.178a1 1 0 101.364-1.462L9.798 14.013c-.404-.376-1.112-.354-1.49.05a1 1 0 00.05 1.413l10.4 9.702z" />
            <path d="M9.722 15.476a1 1 0 01-1.364-1.463l10.4-9.702a1 1 0 011.364 1.463l-10.4 9.702z" />
        </g>
    </svg>
)

export const PauseIcon = ({ className }: IconProps) => (
    <div className={className}>
        <PauseIconComponent size={18} />
    </div>
)

export const PlayIcon = ({ className }: IconProps) => (
    <div className={className}>
        <PlayIconComponent size={18} />
    </div>
)

export const HandIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 30" className={className}>
        <path
            d="M22.4 26.842H20V30H8v-3.158h-.8l-.001-2.369H4.8l-.001-3.158H3.2l-.001-3.158H1.6v-1.579H0v-3.157h3.2V15h1.6v1.578h1.6V0h3.2v13.421h1.6V7.105h3.2l-.001 6.316H16V8.684h3.2L19.199 15H20.8v-3.947h1.6v1.579H24v11.842h-1.6v2.368z"
            fill={giphyLightCharcoal}
            fillRule="evenodd"
        />
    </svg>
)

export const CollectionScreenIcon = ({ className }: IconProps) => (
    <svg
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={{ verticalAlign: 'middle' }}
    >
        <path
            d="M14.0732 18.3799C14.4229 18.3799 14.7065 18.6598 14.7065 19.0049C14.7065 19.3501 14.4229 19.6299 14.0732 19.6299H3.90144C3.55166 19.6299 3.26811 19.3501 3.26811 19.0049C3.26811 18.6598 3.55166 18.3799 3.90144 18.3799H14.0732ZM15.7072 15.9293C16.057 15.9293 16.3405 16.2091 16.3405 16.5543C16.3405 16.8995 16.057 17.1793 15.7072 17.1793H2.26739C1.91761 17.1793 1.63405 16.8995 1.63405 16.5543C1.63405 16.2091 1.91761 15.9293 2.26739 15.9293H15.7072ZM15.6183 0C16.9197 0 17.9746 0.995482 17.9746 2.22347V12.4805C17.9746 13.7085 16.9197 14.7039 15.6183 14.7039H2.35627C1.05494 14.7039 0 13.7085 0 12.4805V2.22347C0 0.995482 1.05494 0 2.35627 0H15.6183Z"
            fill="#5C5C5C"
        />
    </svg>
)

export const ScreensIcon = ({ className }: IconProps) => (
    <svg
        width="15px"
        height="16px"
        viewBox="0 0 15 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g id="📂-Collections-Cabinet" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Upload-Collections-Expanded-(GIF)"
                transform="translate(-752.000000, -789.000000)"
                fill="#5C5C5C"
                fillRule="nonzero"
            >
                <g id="right-panel" transform="translate(722.000000, 104.000000)">
                    <g id="add-to-collection" transform="translate(27.000000, 683.000000)">
                        <g id="Stories" transform="translate(3.000000, 0.000000)">
                            <path
                                d="M11.1103892,16.7039469 C11.3865316,16.7039469 11.6103892,16.9278045 11.6103892,17.2039469 C11.6103892,17.4800892 11.3865316,17.7039469 11.1103892,17.7039469 L3.08008649,17.7039469 C2.80394412,17.7039469 2.58008649,17.4800892 2.58008649,17.2039469 C2.58008649,16.9278045 2.80394412,16.7039469 3.08008649,16.7039469 L11.1103892,16.7039469 Z M12.4004325,14.7434206 C12.6765748,14.7434206 12.9004325,14.9672783 12.9004325,15.2434206 C12.9004325,15.519563 12.6765748,15.7434206 12.4004325,15.7434206 L1.79004325,15.7434206 C1.51390087,15.7434206 1.29004325,15.519563 1.29004325,15.2434206 C1.29004325,14.9672783 1.51390087,14.7434206 1.79004325,14.7434206 L12.4004325,14.7434206 Z M12.3302589,2 C13.3576283,2 14.1904757,2.79638547 14.1904757,3.77877672 L14.1904757,3.77877672 L14.1904757,11.9843808 C14.1904757,12.966772 13.3576283,13.7631575 12.3302589,13.7631575 L12.3302589,13.7631575 L1.86021682,13.7631575 C0.832847437,13.7631575 0,12.966772 0,11.9843808 L0,11.9843808 L0,3.77877672 C0,2.79638547 0.832847437,2 1.86021682,2 L1.86021682,2 Z"
                                id="collections"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const SoundOnIcon = ({ className }: IconProps) => (
    <div className={className}>
        <VolumeOnIcon size={22} />
    </div>
)

export const SoundOffIcon = ({ className }: IconProps) => (
    <div className={className}>
        <VolumeOffIcon size={22} />
    </div>
)

export const StaircaseIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 67" className={className}>
        <path fill="#FFF" d="M44.667 44.667V22.333H22.333V0H0v67h67V44.667z" fillRule="evenodd" />
    </svg>
)

export const EditorIcon = ({ className, colors }: GradientIconProps) => {
    const filterId = useRef(getFilterId())
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
                <linearGradient x1="-15.466%" y1="113.324%" x2="127.445%" y2="-27.204%" id={filterId.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`editorcolor${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
            </defs>
            <path
                d="M18.144 8.409l1.843-1.842c.214-.215.32-.47.32-.765 0-.296-.106-.557-.32-.782l-1.699-1.699a1.101 1.101 0 00-.782-.32c-.295 0-.55.106-.764.32l-1.843 1.843 3.245 3.245zM3.364 20.308c.05 0 .095-.006.135-.017l4.53-1.809a.328.328 0 00.118-.076l8.916-8.915-3.246-3.246-8.915 8.916a.328.328 0 00-.076.119l-1.809 4.53c-.04.168-.011.3.085.396a.415.415 0 00.262.102z"
                fill={`url(#${filterId.current})`}
                transform="matrix(0 -1 -1 0 23.308 23.308)"
                fillRule="evenodd"
            />
        </svg>
    )
}

export const CaptionEditorIcon = ({ className, colors }: GradientIconProps) => {
    const filterId = useRef(getFilterId())
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
            <defs>
                <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id={filterId.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`captioneditorcolor${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
            </defs>
            <path
                d="M19.68 6c7.732 0 14 6.268 14 14v14h-14c-7.732 0-14-6.268-14-14s6.268-14 14-14zM22 15h-8v1.986h2.933V25h2.134v-8.014H22V15zm3.053 1l-1.895.225v1.715H22v1.686h1.158v2.614c0 2.165 1.066 2.825 2.474 2.755a3.82 3.82 0 001.368-.31L26.566 23c-.21.113-.566.169-.79.169-.355 0-.737-.197-.737-.928v-2.614h1.658V17.94h-1.644V16z"
                fill={`url(#${filterId.current})`}
                fillRule="evenodd"
            />
        </svg>
    )
}

export const TrimEditorIcon = ({ className, colors }: GradientIconProps) => {
    const filterId1 = useRef(getFilterId())
    const filterId2 = useRef(getFilterId())
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
                <linearGradient x1="-15.466%" y1="75.644%" x2="100%" y2="4.804%" id={filterId1.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`trimeditorcolora${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
                <linearGradient x1="-15.466%" y1="113.326%" x2="100%" y2="-61.608%" id={filterId2.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`trimeditorcolorb${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
            </defs>
            <g
                transform="translate(5 5)"
                strokeWidth="2"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path stroke={`url(#${filterId1.current})`} d="M4 5l11 7" />
                <path stroke={`url(#${filterId1.current})`} transform="matrix(1 0 0 -1 0 13)" d="M4 3l11 7" />
                <circle stroke={`url(#${filterId2.current})`} cx="2.5" cy="2.5" r="2.5" />
                <circle stroke={`url(#${filterId2.current})`} cx="2.5" cy="12.5" r="2.5" />
            </g>
        </svg>
    )
}

export const CropEditorIcon = ({ className, colors }: GradientIconProps) => {
    const filterId = useRef(getFilterId())
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
                <linearGradient x1="-24.95%" y1="134.9%" x2="100%" y2="0%" id={filterId.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`cropeditorcolor${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
            </defs>
            <g
                transform="translate(3 3)"
                stroke={`url(#${filterId.current})`}
                strokeWidth="2.25"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M4 0v14h14" />
                <path d="M14 18V4H0" />
            </g>
        </svg>
    )
}

export const FilterEditorIcon = ({ className, colors }: GradientIconProps) => {
    const filterId1 = useRef(getFilterId())
    const filterId2 = useRef(getFilterId())
    const filterId3 = useRef(getFilterId())
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
                <linearGradient x1="225.292%" y1="-98.125%" x2="-101.692%" y2="257.378%" id={filterId1.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`filtereditorcolora${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
                <linearGradient x1="90.801%" y1="0%" x2="-21.294%" y2="132.018%" id={filterId2.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`filtereditorcolorb${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
                <linearGradient x1="127.072%" y1="-19.497%" x2="19.207%" y2="100%" id={filterId3.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`filtereditorcolorc${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
            </defs>
            <g transform="translate(3 3)" fill="none" fillRule="evenodd">
                <path stroke={`url(#${filterId1.current})`} strokeWidth="1.5" d="M6 10l4-4M8 12l4-4" />
                <circle stroke={`url(#${filterId2.current})`} strokeWidth="2" cx="11" cy="7" r="6" />
                <circle stroke={`url(#${filterId3.current})`} strokeWidth="2" cx="7" cy="11" r="6" />
            </g>
        </svg>
    )
}

export const StickerEditorIcon = ({ className, colors }: GradientIconProps) => {
    const filterId = useRef(getFilterId())
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
            <defs>
                <linearGradient x1="99.71%" y1="0%" x2=".29%" y2="100%" id={filterId.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`stickereditorcolor${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
            </defs>
            <path
                d="M20.82 4.95c6.913 0 12.889 4.972 14.442 11.73.033.145.035.292.008.434A12.94 12.94 0 0030 16c-7.18 0-13 5.82-13 13 0 1.896.406 3.696 1.135 5.32-.19.065-.4.073-.602.018C10.977 32.576 5.95 26.49 5.95 19.82c0-8.213 6.657-14.87 14.87-14.87zM30 18.1c1.353 0 2.648.247 3.843.698l-10.85 10.874-3.059 3.043-.135.131A10.875 10.875 0 0119.1 29c0-6.02 4.88-10.9 10.899-10.9z"
                fill={`url(#${filterId.current})`}
                fillRule="evenodd"
            />
        </svg>
    )
}

export const WatermarkEditorIcon = ({ className, colors }: GradientIconProps) => {
    const filterId = useRef(getFilterId())
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
                <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id={filterId.current}>
                    {colors.map((color, i) => (
                        <stop
                            key={`watermarkeditorcolor${i}`}
                            stopColor={color}
                            offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                        />
                    ))}
                </linearGradient>
            </defs>
            <g transform="translate(4 4)" fill="none" fillRule="evenodd">
                <rect
                    stroke={`url(#${filterId.current})`}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width="16"
                    height="16"
                    rx="1"
                />
                <rect fill={`url(#${filterId.current})`} x="7" y="7" width="7" height="7" rx="1" />
            </g>
        </svg>
    )
}

export const LayerEditorIcon = () => {
    return (
        <svg
            viewBox="0 0 50 50"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                height: '45px',
                width: '45px',
            }}
        >
            <title>icons/toolbar/layers</title>
            <defs>
                <linearGradient
                    x1="24.6532976%"
                    y1="113.326208%"
                    x2="79.9849917%"
                    y2="-27.207446%"
                    id="linearGradient-1"
                >
                    <stop stopColor="#FF6666" offset="0%"></stop>
                    <stop stopColor="#FFF35C" offset="100%"></stop>
                </linearGradient>
                <linearGradient
                    x1="-15.4655074%"
                    y1="70.0706309%"
                    x2="127.445289%"
                    y2="25.5298447%"
                    id="linearGradient-2"
                >
                    <stop stopColor="#FF6666" offset="0%"></stop>
                    <stop stopColor="#FFF35C" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="icons/toolbar/layers" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="tool/trim">
                    <g id="tool/layers" transform="translate(0.000000, 0.000000)"></g>
                    <g id="tool/trim">
                        <rect id="Rectangle" x="3.63797881e-12" y="0" width="50" height="50" rx="4"></rect>
                        <g id="tool/layers" strokeWidth="2.5">
                            <g id="icons/create/layers-(outline)" transform="translate(9.800000, 12.200000)">
                                <path
                                    d="M16.8410876,-3.08622069 C17.3073894,-2.64239933 17.3707623,-2.19637783 17.3707623,-1.64485312 L17.3707623,-1.64485312 L17.3707952,9.45215248 C17.3784119,10.5021524 17.1359453,10.9252634 16.2996474,11.4373136 L16.2996474,11.4373136 L7.17538954,16.962986 C6.76904194,17.2040022 6.41296869,17.3710207 6.1041095,17.3710207 C5.64777424,16.9314799 5.58622069,16.4857126 5.58622069,15.9420557 L5.58622069,15.9420557 L5.58622069,4.85411743 C5.58622069,3.79002502 5.80645843,3.38024121 6.6825808,2.8464712 L6.6825808,2.8464712 L15.802052,-2.6957801 C16.1944151,-2.93281138 16.5450166,-3.08622069 16.8410876,-3.08622069 Z"
                                    id="Path"
                                    stroke="url(#linearGradient-1)"
                                    transform="translate(11.478621, 7.142400) scale(-1, 1) rotate(-90.000000) translate(-11.478621, -7.142400) "
                                ></path>
                                <path
                                    d="M5.23586207,18.6496 L19.3324138,18.6496 L26.3806897,6.7456"
                                    id="Path-4"
                                    stroke="url(#linearGradient-2)"
                                ></path>
                                <path
                                    d="M8.25655172,24.6016 L22.3531034,24.6016 L29.4013793,12.6976"
                                    id="Path-4"
                                    stroke="url(#linearGradient-2)"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export const DuplicateWhiteIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/duplicate</title>
        <defs>
            <path
                d="M17.7592773,18.3071289 L17.9750977,18.3071289 C19.4692383,18.3071289 20.6645508,17.4272461 20.6645508,15.4682617 L20.6645508,7.68212891 L15.949707,7.68212891 C15.1279297,7.68212891 14.5800781,7.13427734 14.5800781,6.32080078 L14.5800781,1.34033203 L10.0893555,1.34033203 C8.31298828,1.34033203 7.30029297,2.33642578 7.30029297,4.09619141 L7.30029297,4.41992187 L8.64501953,4.41992187 C10.0478516,4.41992187 11.0107422,4.76025391 11.9155273,5.66503906 L16.6303711,10.3798828 C17.5102539,11.2597656 17.7592773,12.3305664 17.7592773,13.6503906 L17.7592773,18.3071289 Z M16.2236328,6.49511719 L20.4985352,6.49511719 C20.465332,6.19628906 20.2412109,5.93066406 19.9008789,5.58203125 L16.6635742,2.24511719 C16.3481445,1.91308594 16.065918,1.69726562 15.7670898,1.6640625 L15.7670898,6.03857422 C15.7670898,6.35400391 15.8999023,6.49511719 16.2236328,6.49511719 Z M5.93066406,22.6650391 L13.6669922,22.6650391 C15.5014648,22.6650391 16.480957,21.6772461 16.480957,19.8344727 L16.480957,13.4926758 L10.4711914,13.4926758 C9.42529297,13.4926758 8.88574219,12.9614258 8.88574219,11.9072266 L8.88574219,5.70654297 L5.93066406,5.70654297 C4.09619141,5.70654297 3.11669922,6.69433594 3.11669922,8.53710937 L3.11669922,19.8344727 C3.11669922,21.6855469 4.09619141,22.6650391 5.93066406,22.6650391 Z M10.637207,12.2143555 L16.3232422,12.2143555 C16.2236328,11.8325195 15.9829102,11.4672852 15.6010742,11.0688477 L11.2763672,6.69433594 C10.8862305,6.30419922 10.5541992,6.03857422 10.1723633,5.92236328 L10.1723633,11.7329102 C10.1723633,12.0483398 10.3383789,12.2143555 10.637207,12.2143555 Z"
                id="path-1"
            ></path>
        </defs>
        <g id="icons/layer_editor/duplicate" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Shape" fillRule="nonzero" fill="#FFFFFF">
                <use xlinkHref="#path-1"></use>
                <use xlinkHref="#path-1"></use>
            </g>
        </g>
    </svg>
)

export const FlipWhiteIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/flip</title>
        <defs>
            <path
                d="M1.23583984,20.5524464 C1.23583984,20.9003468 1.35214488,21.1997102 1.58475494,21.4505367 C1.81736501,21.7013633 2.17256165,21.8267765 2.65034485,21.8267765 L9.6312561,21.8267765 C10.1759135,21.8267765 10.5788981,21.6961206 10.84021,21.4348087 C11.1015218,21.1734969 11.2321777,20.7705123 11.2321777,20.2258549 L11.2321777,9.80406381 C11.2321777,9.51936532 11.1695073,9.27755039 11.0441666,9.07861902 C10.9188258,8.87968764 10.7535731,8.72909992 10.5484085,8.62685586 C10.3432439,8.5246118 10.1223755,8.47348978 9.88580322,8.47348978 C9.64207967,8.47348978 9.4077301,8.52859816 9.18275452,8.63881494 C8.95777893,8.74903172 8.76493581,8.92716155 8.60422516,9.17320444 L1.53749847,19.5770207 C1.43370819,19.73058 1.35748418,19.8902518 1.30882645,20.056036 C1.26016871,20.2218202 1.23583984,20.3872903 1.23583984,20.5524464 Z M12.2906647,20.2258549 C12.2906647,20.7705123 12.4199193,21.1734969 12.6784286,21.4348087 C12.936938,21.6961206 13.3413239,21.8267765 13.8915863,21.8267765 L20.8651047,21.8267765 C21.3478165,21.8267765 21.7054774,21.7013633 21.9380875,21.4505367 C22.1706975,21.1997102 22.2870026,20.9003468 22.2870026,20.5524464 C22.2870026,20.3872903 22.2626737,20.2218202 22.214016,20.056036 C22.1653582,19.8902518 22.0891342,19.73058 21.9853439,19.5770207 L14.9103546,9.17320444 C14.7495473,8.92716155 14.5580571,8.74903172 14.3358841,8.63881494 C14.113711,8.52859816 13.8779602,8.47348978 13.6286316,8.47348978 C13.3976644,8.47348978 13.1795985,8.5246118 12.9744339,8.62685586 C12.7692693,8.72909992 12.6040166,8.87968764 12.4786758,9.07861902 C12.3533351,9.27755039 12.2906647,9.51936532 12.2906647,9.80406381 L12.2906647,20.2258549 Z M2.60410309,5.01825906 L4.98707581,6.79559518 C5.23485819,6.98587737 5.47954814,7.03344792 5.72114563,6.93830682 C5.96274312,6.84316573 6.08354187,6.63986144 6.08354187,6.32839395 L6.08354187,5.08754922 L17.4393005,5.08754922 L17.4393005,6.32839395 C17.4393005,6.63986144 17.5602442,6.84316573 17.8021317,6.93830682 C18.0440191,7.03344792 18.288564,6.98587737 18.5357666,6.79559518 L20.9187393,5.01825906 C21.0831223,4.89775023 21.1651688,4.73969715 21.1648796,4.54409982 C21.1645889,4.34850249 21.0825424,4.19044941 20.9187393,4.06994058 L18.5357666,2.28245737 C18.2935893,2.0976836 18.0503006,2.0500889 17.8059006,2.13967325 C17.5615005,2.2292576 17.4393005,2.43625833 17.4393005,2.76067544 L17.4393005,3.98021127 L6.08354187,3.98021127 L6.08354187,2.76067544 C6.08354187,2.44244323 5.96274312,2.23561161 5.72114563,2.1401806 C5.47954814,2.04474959 5.23485819,2.09217518 4.98707581,2.28245737 L2.60410309,4.06994058 C2.44029999,4.19044941 2.35839844,4.34850249 2.35839844,4.54409982 C2.35839844,4.73969715 2.44029999,4.89775023 2.60410309,5.01825906 Z"
                id="path-flip"
            ></path>
        </defs>
        <g id="icons/layer_editor/flip" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Shape" fillRule="nonzero" fill="#FFFFFF">
                <use xlinkHref="#path-flip"></use>
                <use xlinkHref="#path-flip"></use>
            </g>
        </g>
    </svg>
)

export const SendToBackWhiteIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/send_arrow</title>
        <defs>
            <path
                d="M10.5959473,19.6085041 C10.8837077,19.6085041 11.1202799,19.5144286 11.3056641,19.3262775 C11.4910482,19.1381265 11.5837402,18.9001708 11.5837402,18.6124103 L11.5837402,15.6988361 L11.7995605,15.6988361 C12.7845866,15.6988361 13.6534017,15.799829 14.4060059,16.0018146 C15.15861,16.2038003 15.8199056,16.5413654 16.3898926,17.01451 C16.9598796,17.4876545 17.4634603,18.130965 17.9006348,18.9444416 C18.044515,19.2100666 18.2063802,19.384383 18.3862305,19.4673908 C18.5660807,19.5503986 18.7473145,19.5919025 18.9299316,19.5919025 C19.1734212,19.5919025 19.3823242,19.4826089 19.5566406,19.2640217 C19.730957,19.0454344 19.8181152,18.7286213 19.8181152,18.3135822 C19.8181152,16.8747801 19.6590169,15.5812417 19.3408203,14.432967 C19.0226237,13.2846922 18.537028,12.3065835 17.8840332,11.4986408 C17.2310384,10.6906981 16.3995768,10.0736734 15.3896484,9.6475666 C14.3797201,9.22145982 13.1830241,9.00840644 11.7995605,9.00840644 L11.5837402,9.00840644 L11.5837402,6.11973456 C11.5837402,5.837508 11.4896647,5.59540188 11.3015137,5.3934162 C11.1133626,5.19143053 10.8754069,5.09043769 10.5876465,5.09043769 C10.3828939,5.09043769 10.1988932,5.13470852 10.0356445,5.22325019 C9.87239583,5.31179186 9.68286133,5.46120592 9.46704102,5.67149238 L3.25805664,11.4654377 C3.10864258,11.6093179 3.00349935,11.7573485 2.94262695,11.9095295 C2.88175456,12.0617105 2.85131836,12.2069741 2.85131836,12.3453205 C2.85131836,12.478133 2.88175456,12.6220132 2.94262695,12.7769611 C3.00349935,12.931909 3.10864258,13.0813231 3.25805664,13.2252033 L9.46704102,19.0689533 C9.66625977,19.2515705 9.85441081,19.3871499 10.0314941,19.4756916 C10.2085775,19.5642333 10.3967285,19.6085041 10.5959473,19.6085041 Z"
                id="path-1"
            ></path>
        </defs>
        <g id="icons/layer_editor/send_arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Path"
                fillRule="nonzero"
                transform="translate(11.334717, 12.349471) rotate(-90.000000) translate(-11.334717, -12.349471) "
                fill="#FFFFFF"
            >
                <use xlinkHref="#path-1"></use>
                <use xlinkHref="#path-1"></use>
            </g>
        </g>
    </svg>
)

export const MenuRemoveIcon = ({ className, colors }: GradientIconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <defs>
            <linearGradient x1="95.308%" y1="0%" x2="4.692%" y2="100%" id="menudeletegradient">
                {colors.map((color, i) => (
                    <stop
                        key={`menudeletecolor${i}`}
                        stopColor={color}
                        offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                    />
                ))}
            </linearGradient>
        </defs>
        <path
            d="M18.819 6.857c.09 0 .167-.03.23-.09a.296.296 0 00.094-.222V5.312a.296.296 0 00-.094-.221.319.319 0 00-.23-.091H5.324c-.09 0-.167.03-.23.09A.296.296 0 005 5.313v1.233c0 .087.031.161.094.221s.14.091.23.091h13.495zm-2.252 13c.08 0 .152-.026.215-.08a.3.3 0 00.11-.196l.963-11.483H6.288l.964 11.483a.3.3 0 00.109.196c.063.054.134.08.215.08h8.991z"
            fill="url(#menudeletegradient)"
            fillRule="evenodd"
        />
    </svg>
)

export const MenuAddIcon = ({ className, colors }: GradientIconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <defs>
            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="menuaddgradient">
                {colors.map((color, i) => (
                    <stop
                        key={`menuaddcolor${i}`}
                        stopColor={color}
                        offset={`${Math.round((i / (colors.length - 1)) * 100)}%`}
                    />
                ))}
            </linearGradient>
        </defs>
        <path
            d="M13.456 19a.284.284 0 00.209-.085.284.284 0 00.085-.209V13.75h4.956a.284.284 0 00.209-.085.284.284 0 00.085-.209v-2.912a.284.284 0 00-.085-.209.284.284 0 00-.209-.085H13.75V5.294a.284.284 0 00-.085-.209.284.284 0 00-.209-.085h-2.912a.284.284 0 00-.209.085.284.284 0 00-.085.209v4.956H5.294a.284.284 0 00-.209.085.284.284 0 00-.085.209v2.912c0 .082.028.152.085.209a.284.284 0 00.209.085h4.956v4.956c0 .082.028.152.085.209a.284.284 0 00.209.085h2.912z"
            fill="url(#menuaddgradient)"
            fillRule="nonzero"
        />
    </svg>
)

export const TrashIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
        <defs>
            <linearGradient x1="100%" y1="49.07%" x2="0%" y2="50.93%" id="trashicongradient1">
                <stop stopColor="#F66" offset="0%" />
                <stop stopColor="#E646B6" offset="100%" />
            </linearGradient>
            <linearGradient x1="94.862%" y1="0%" x2="5.138%" y2="100%" id="trashicongradient2">
                <stop stopColor="#F66" offset="0%" />
                <stop stopColor="#E646B6" offset="100%" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                d="M31.496 12c.14 0 .26-.049.358-.146a.486.486 0 00.146-.358V9.504c0-.14-.049-.26-.146-.358A.486.486 0 0031.496 9H10.504c-.14 0-.26.049-.358.146a.486.486 0 00-.146.358v1.992c0 .14.049.26.146.358a.486.486 0 00.358.146h20.992z"
                fill="url(#trashicongradient1)"
            />
            <path
                d="M27.994 33a.491.491 0 00.333-.129.49.49 0 00.17-.316l1.5-18.551H12.003l1.5 18.55a.49.49 0 00.17.317.491.491 0 00.333.129h13.988z"
                fill="url(#trashicongradient2)"
            />
        </g>
    </svg>
)

export const AllLayersIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="icons/layer_editor/layers" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M5.04435146,16.68 C5.21962723,16.68 5.40220616,16.6356324 5.5993914,16.5247135 L5.5993914,8.83433514 C5.5993914,8.30192432 5.67972613,8.14663784 6.13982503,7.88043243 L12.7272727,4.03524324 C12.6980601,3.37712432 12.2817801,3 11.7267402,3 C11.4638266,3 11.1790034,3.07394595 10.8868771,3.25141622 L4.95671358,6.70469189 C4.12415367,7.19273514 4,7.38499459 4,8.38326486 L4,15.2602378 C4,16.1032216 4.41627995,16.68 5.04435146,16.68 Z M8.68713895,18.84 C8.85497112,18.84 9.04469444,18.7882658 9.24171481,18.6774068 L9.24171481,10.9985737 C9.24171481,10.4516694 9.31468531,10.311248 9.78169656,10.0451864 L16.3636364,6.20207455 C16.3417452,5.54431118 15.9185163,5.16 15.3566434,5.16 C15.1012466,5.16 14.8166616,5.2412966 14.5174825,5.41128039 L8.59957434,8.87008104 C7.7604135,9.35047002 7.63636364,9.55740681 7.63636364,10.5477472 L7.63636364,17.4136143 C7.63636364,18.2635332 8.06688963,18.84 8.68713895,18.84 Z M12.3528157,21 C12.6480399,21 13.0008688,20.8817504 13.3969013,20.6526418 L18.9773584,17.3564344 C19.7694233,16.883436 20.0070427,16.4991248 19.9998421,15.5309562 L19.9998421,8.92376013 C19.9998421,7.88168558 19.5822079,7.32 18.9125531,7.32 C18.6245295,7.32 18.2717006,7.430859 17.8828687,7.65996759 L12.3096122,10.9635656 C11.488745,11.4513452 11.2727273,11.8208752 11.2727273,12.7964344 L11.2727273,19.4036305 C11.2727273,20.4235332 11.6759603,21 12.3528157,21 Z"
                id="􀐝"
                fill="#5C5C5C"
                fillRule="nonzero"
                transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-12.000000, -12.000000) "
            ></path>
        </g>
    </svg>
)

export const LayerTextIcon = () => (
    <svg width="29px" height="28px" viewBox="0 0 29 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/gradient/text</title>
        <defs>
            <linearGradient x1="100%" y1="-5.55111512e-15%" x2="1.11022302e-14%" y2="100%" id="layerTextIcon-1">
                <stop stopColor="#FF6666" offset="0%"></stop>
                <stop stopColor="#E646B6" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/gradient/text" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(0.680000, 0.000000)" fill="url(#layerTextIcon-1)" id="Combined-Shape">
                <path d="M14,0 C21.7319865,-1.42034288e-15 28,6.2680135 28,14 L28,28 L14,28 C6.2680135,28 9.46895252e-16,21.7319865 0,14 C-9.46895252e-16,6.2680135 6.2680135,1.42034288e-15 14,0 Z M16.32,9 L8.32,9 L8.32,10.9857143 L11.2528744,10.9857143 L11.2528744,19 L13.3871256,19 L13.3871256,10.9857143 L16.32,10.9857143 L16.32,9 Z M19.3726316,10 L17.4778947,10.2248754 L17.4778947,11.9395501 L16.32,11.9395501 L16.32,13.6261154 L17.4778947,13.6261154 L17.4778947,16.2402916 C17.4778947,18.4047171 18.5436842,19.0652885 19.9515789,18.995015 C20.4647368,18.9669056 20.8463158,18.8825773 21.32,18.6858113 L21.32,18.6858113 L20.8857895,16.999246 C20.6752632,17.1116837 20.32,17.1679026 20.0963158,17.1679026 C19.7410526,17.1679026 19.3594737,16.9711366 19.3594737,16.2402916 L19.3594737,16.2402916 L19.3594737,13.6261154 L21.0173684,13.6261154 L21.0173684,11.9395501 L19.3726316,11.9395501 L19.3726316,10 Z"></path>
            </g>
        </g>
    </svg>
)

export const LayerTextWhiteIcon = () => (
    <svg width="29px" height="28px" viewBox="0 0 29 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/gradient/text</title>
        <defs>
            <linearGradient x1="100%" y1="-5.55111512e-15%" x2="1.11022302e-14%" y2="100%" id="layerTextWhiteIcon-1">
                <stop stopColor="#FFFFFF" offset="0%"></stop>
                <stop stopColor="#FFFFFF" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/gradient/text" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(0.680000, 0.000000)" fill="url(#layerTextWhiteIcon-1)" id="Combined-Shape">
                <path d="M14,0 C21.7319865,-1.42034288e-15 28,6.2680135 28,14 L28,28 L14,28 C6.2680135,28 9.46895252e-16,21.7319865 0,14 C-9.46895252e-16,6.2680135 6.2680135,1.42034288e-15 14,0 Z M16.32,9 L8.32,9 L8.32,10.9857143 L11.2528744,10.9857143 L11.2528744,19 L13.3871256,19 L13.3871256,10.9857143 L16.32,10.9857143 L16.32,9 Z M19.3726316,10 L17.4778947,10.2248754 L17.4778947,11.9395501 L16.32,11.9395501 L16.32,13.6261154 L17.4778947,13.6261154 L17.4778947,16.2402916 C17.4778947,18.4047171 18.5436842,19.0652885 19.9515789,18.995015 C20.4647368,18.9669056 20.8463158,18.8825773 21.32,18.6858113 L21.32,18.6858113 L20.8857895,16.999246 C20.6752632,17.1116837 20.32,17.1679026 20.0963158,17.1679026 C19.7410526,17.1679026 19.3594737,16.9711366 19.3594737,16.2402916 L19.3594737,16.2402916 L19.3594737,13.6261154 L21.0173684,13.6261154 L21.0173684,11.9395501 L19.3726316,11.9395501 L19.3726316,10 Z"></path>
            </g>
        </g>
    </svg>
)

export const DuplicateGradientIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/duplicate</title>
        <defs>
            <linearGradient
                x1="16.1427437%"
                y1="100%"
                x2="83.8572563%"
                y2="3.74939946e-31%"
                id="linearGradient-duplicate"
            >
                <stop stopColor="#6157FF" offset="0%"></stop>
                <stop stopColor="#00CCFF" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/layer_editor/duplicate" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M17.7592773,18.3071289 L17.9750977,18.3071289 C19.4692383,18.3071289 20.6645508,17.4272461 20.6645508,15.4682617 L20.6645508,7.68212891 L15.949707,7.68212891 C15.1279297,7.68212891 14.5800781,7.13427734 14.5800781,6.32080078 L14.5800781,1.34033203 L10.0893555,1.34033203 C8.31298828,1.34033203 7.30029297,2.33642578 7.30029297,4.09619141 L7.30029297,4.41992187 L8.64501953,4.41992187 C10.0478516,4.41992187 11.0107422,4.76025391 11.9155273,5.66503906 L16.6303711,10.3798828 C17.5102539,11.2597656 17.7592773,12.3305664 17.7592773,13.6503906 L17.7592773,18.3071289 Z M16.2236328,6.49511719 L20.4985352,6.49511719 C20.465332,6.19628906 20.2412109,5.93066406 19.9008789,5.58203125 L16.6635742,2.24511719 C16.3481445,1.91308594 16.065918,1.69726562 15.7670898,1.6640625 L15.7670898,6.03857422 C15.7670898,6.35400391 15.8999023,6.49511719 16.2236328,6.49511719 Z M5.93066406,22.6650391 L13.6669922,22.6650391 C15.5014648,22.6650391 16.480957,21.6772461 16.480957,19.8344727 L16.480957,13.4926758 L10.4711914,13.4926758 C9.42529297,13.4926758 8.88574219,12.9614258 8.88574219,11.9072266 L8.88574219,5.70654297 L5.93066406,5.70654297 C4.09619141,5.70654297 3.11669922,6.69433594 3.11669922,8.53710937 L3.11669922,19.8344727 C3.11669922,21.6855469 4.09619141,22.6650391 5.93066406,22.6650391 Z M10.637207,12.2143555 L16.3232422,12.2143555 C16.2236328,11.8325195 15.9829102,11.4672852 15.6010742,11.0688477 L11.2763672,6.69433594 C10.8862305,6.30419922 10.5541992,6.03857422 10.1723633,5.92236328 L10.1723633,11.7329102 C10.1723633,12.0483398 10.3383789,12.2143555 10.637207,12.2143555 Z"
                id="Shape"
                fill="url(#linearGradient-duplicate)"
                fillRule="nonzero"
            ></path>
        </g>
    </svg>
)

export const TimingGradientIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/timing</title>
        <defs>
            <linearGradient x1="100%" y1="0.00562834434%" x2="0%" y2="99.9943717%" id="linearGradient-timing">
                <stop stopColor="#00FF99" offset="0%"></stop>
                <stop stopColor="#00CCFF" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/layer_editor/timing" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M7.50458527,13.0350418 C7.31826528,13.0350418 7.16185506,12.9718157 7.03535461,12.8453636 C6.90885417,12.7189115 6.84560394,12.5628153 6.84560394,12.3770752 C6.84560394,12.1969401 6.90885417,12.0436465 7.03535461,11.9171944 C7.16185506,11.7907422 7.31826528,11.7275162 7.50458527,11.7275162 L11.3555527,11.7275162 L11.3555527,6.54771423 C11.3555527,6.36699931 11.4187787,6.21356074 11.5452309,6.08739853 C11.671683,5.96123632 11.8249766,5.89815521 12.0051117,5.89815521 C12.1914317,5.89815521 12.3478419,5.96123632 12.4743423,6.08739853 C12.6008428,6.21356074 12.664093,6.36699931 12.664093,6.54771423 L12.664093,12.3770752 C12.664093,12.5628153 12.6008428,12.7189115 12.4743423,12.8453636 C12.3478419,12.9718157 12.1914317,13.0350418 12.0051117,13.0350418 L7.50458527,13.0350418 Z M12.014389,21.0270386 C13.2479858,21.0270386 14.4081612,20.7906837 15.494915,20.3179741 C16.5816689,19.8452644 17.5405693,19.1949323 18.3716164,18.3669777 C19.2026634,17.5390231 19.8531647,16.5815239 20.3231201,15.4944801 C20.7930756,14.4074364 21.0280533,13.2471161 21.0280533,12.0135193 C21.0280533,10.7799225 20.7916743,9.61962636 20.3189163,8.53263092 C19.8461583,7.44563548 19.1942558,6.48675919 18.3632088,5.65600204 C17.5321617,4.8252449 16.5732613,4.17488861 15.4865074,3.70493317 C14.3997536,3.23497772 13.2392883,3 12.0051117,3 C10.77712,3 9.61977132,3.23497772 8.5330658,3.70493317 C7.44636027,4.17488861 6.48748398,4.8252449 5.65643692,5.65600204 C4.82538986,6.48675919 4.17488861,7.44563548 3.70493317,8.53263092 C3.23497772,9.61962636 3,10.7799225 3,12.0135193 C3,13.2471161 3.23637899,14.4074364 3.70913696,15.4944801 C4.18189494,16.5815239 4.83239619,17.5390231 5.66064072,18.3669777 C6.48888524,19.1949323 7.44636027,19.8452644 8.5330658,20.3179741 C9.61977132,20.7906837 10.7802124,21.0270386 12.014389,21.0270386 Z"
                id="Shape"
                fill="url(#linearGradient-timing)"
                fillRule="nonzero"
            ></path>
        </g>
    </svg>
)

export const FlipGradientIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/flip</title>
        <defs>
            <linearGradient x1="100%" y1="6.05939373%" x2="0%" y2="93.9406063%" id="linearGradient-flip">
                <stop stopColor="#9933FF" offset="0%"></stop>
                <stop stopColor="#6157FF" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/layer_editor/flip" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M1.23583984,20.5524464 C1.23583984,20.9003468 1.35214488,21.1997102 1.58475494,21.4505367 C1.81736501,21.7013633 2.17256165,21.8267765 2.65034485,21.8267765 L9.6312561,21.8267765 C10.1759135,21.8267765 10.5788981,21.6961206 10.84021,21.4348087 C11.1015218,21.1734969 11.2321777,20.7705123 11.2321777,20.2258549 L11.2321777,9.80406381 C11.2321777,9.51936532 11.1695073,9.27755039 11.0441666,9.07861902 C10.9188258,8.87968764 10.7535731,8.72909992 10.5484085,8.62685586 C10.3432439,8.5246118 10.1223755,8.47348978 9.88580322,8.47348978 C9.64207967,8.47348978 9.4077301,8.52859816 9.18275452,8.63881494 C8.95777893,8.74903172 8.76493581,8.92716155 8.60422516,9.17320444 L1.53749847,19.5770207 C1.43370819,19.73058 1.35748418,19.8902518 1.30882645,20.056036 C1.26016871,20.2218202 1.23583984,20.3872903 1.23583984,20.5524464 Z M12.2906647,20.2258549 C12.2906647,20.7705123 12.4199193,21.1734969 12.6784286,21.4348087 C12.936938,21.6961206 13.3413239,21.8267765 13.8915863,21.8267765 L20.8651047,21.8267765 C21.3478165,21.8267765 21.7054774,21.7013633 21.9380875,21.4505367 C22.1706975,21.1997102 22.2870026,20.9003468 22.2870026,20.5524464 C22.2870026,20.3872903 22.2626737,20.2218202 22.214016,20.056036 C22.1653582,19.8902518 22.0891342,19.73058 21.9853439,19.5770207 L14.9103546,9.17320444 C14.7495473,8.92716155 14.5580571,8.74903172 14.3358841,8.63881494 C14.113711,8.52859816 13.8779602,8.47348978 13.6286316,8.47348978 C13.3976644,8.47348978 13.1795985,8.5246118 12.9744339,8.62685586 C12.7692693,8.72909992 12.6040166,8.87968764 12.4786758,9.07861902 C12.3533351,9.27755039 12.2906647,9.51936532 12.2906647,9.80406381 L12.2906647,20.2258549 Z M2.60410309,5.01825906 L4.98707581,6.79559518 C5.23485819,6.98587737 5.47954814,7.03344792 5.72114563,6.93830682 C5.96274312,6.84316573 6.08354187,6.63986144 6.08354187,6.32839395 L6.08354187,5.08754922 L17.4393005,5.08754922 L17.4393005,6.32839395 C17.4393005,6.63986144 17.5602442,6.84316573 17.8021317,6.93830682 C18.0440191,7.03344792 18.288564,6.98587737 18.5357666,6.79559518 L20.9187393,5.01825906 C21.0831223,4.89775023 21.1651688,4.73969715 21.1648796,4.54409982 C21.1645889,4.34850249 21.0825424,4.19044941 20.9187393,4.06994058 L18.5357666,2.28245737 C18.2935893,2.0976836 18.0503006,2.0500889 17.8059006,2.13967325 C17.5615005,2.2292576 17.4393005,2.43625833 17.4393005,2.76067544 L17.4393005,3.98021127 L6.08354187,3.98021127 L6.08354187,2.76067544 C6.08354187,2.44244323 5.96274312,2.23561161 5.72114563,2.1401806 C5.47954814,2.04474959 5.23485819,2.09217518 4.98707581,2.28245737 L2.60410309,4.06994058 C2.44029999,4.19044941 2.35839844,4.34850249 2.35839844,4.54409982 C2.35839844,4.73969715 2.44029999,4.89775023 2.60410309,5.01825906 Z"
                id="Shape"
                fill="url(#linearGradient-flip)"
                fillRule="nonzero"
            ></path>
        </g>
    </svg>
)

export const SendToBackGradientIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/send_arrow</title>
        <defs>
            <linearGradient
                x1="-15.4655074%"
                y1="96.3661803%"
                x2="127.445289%"
                y2="-6.52974445%"
                id="linearGradient-sendToBack"
            >
                <stop stopColor="#FF6666" offset="0%"></stop>
                <stop stopColor="#FFF35C" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/layer_editor/send_arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M10.5959473,19.6085041 C10.8837077,19.6085041 11.1202799,19.5144286 11.3056641,19.3262775 C11.4910482,19.1381265 11.5837402,18.9001708 11.5837402,18.6124103 L11.5837402,15.6988361 L11.7995605,15.6988361 C12.7845866,15.6988361 13.6534017,15.799829 14.4060059,16.0018146 C15.15861,16.2038003 15.8199056,16.5413654 16.3898926,17.01451 C16.9598796,17.4876545 17.4634603,18.130965 17.9006348,18.9444416 C18.044515,19.2100666 18.2063802,19.384383 18.3862305,19.4673908 C18.5660807,19.5503986 18.7473145,19.5919025 18.9299316,19.5919025 C19.1734212,19.5919025 19.3823242,19.4826089 19.5566406,19.2640217 C19.730957,19.0454344 19.8181152,18.7286213 19.8181152,18.3135822 C19.8181152,16.8747801 19.6590169,15.5812417 19.3408203,14.432967 C19.0226237,13.2846922 18.537028,12.3065835 17.8840332,11.4986408 C17.2310384,10.6906981 16.3995768,10.0736734 15.3896484,9.6475666 C14.3797201,9.22145982 13.1830241,9.00840644 11.7995605,9.00840644 L11.5837402,9.00840644 L11.5837402,6.11973456 C11.5837402,5.837508 11.4896647,5.59540188 11.3015137,5.3934162 C11.1133626,5.19143053 10.8754069,5.09043769 10.5876465,5.09043769 C10.3828939,5.09043769 10.1988932,5.13470852 10.0356445,5.22325019 C9.87239583,5.31179186 9.68286133,5.46120592 9.46704102,5.67149238 L3.25805664,11.4654377 C3.10864258,11.6093179 3.00349935,11.7573485 2.94262695,11.9095295 C2.88175456,12.0617105 2.85131836,12.2069741 2.85131836,12.3453205 C2.85131836,12.478133 2.88175456,12.6220132 2.94262695,12.7769611 C3.00349935,12.931909 3.10864258,13.0813231 3.25805664,13.2252033 L9.46704102,19.0689533 C9.66625977,19.2515705 9.85441081,19.3871499 10.0314941,19.4756916 C10.2085775,19.5642333 10.3967285,19.6085041 10.5959473,19.6085041 Z"
                id="Path"
                fill="url(#linearGradient-sendToBack)"
                fillRule="nonzero"
                transform="translate(11.334717, 12.349471) rotate(-90.000000) translate(-11.334717, -12.349471) "
            ></path>
        </g>
    </svg>
)

export const PinGradientIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/pin</title>
        <defs>
            <linearGradient x1="72.0842392%" y1="-5.55111512e-15%" x2="27.9157608%" y2="100%" id="linearGradient-pin">
                <stop stopColor="#FF6666" offset="0%"></stop>
                <stop stopColor="#E646B6" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/layer_editor/pin" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M4.7109375,15.1499023 C4.7109375,16.03125 5.31396484,16.625 6.23242188,16.625 L11.1494141,16.625 L11.1494141,21.0688477 C11.1494141,22.265625 11.8730469,23.7036133 12.1513672,23.7036133 C12.4296875,23.7036133 13.1533203,22.265625 13.1533203,21.0688477 L13.1533203,16.625 L18.0610352,16.625 C18.9794922,16.625 19.5825195,16.03125 19.5825195,15.1499023 C19.5825195,13.1181641 17.9775391,11.0771484 15.3520508,10.09375 L15.0458984,5.73339844 C16.4560547,4.93554687 17.5415039,4.07275391 18.0146484,3.46972656 C18.2744141,3.12646484 18.4042969,2.77392578 18.4042969,2.45849609 C18.4042969,1.79980469 17.9033203,1.32666016 17.1704102,1.32666016 L7.13232422,1.32666016 C6.39941406,1.32666016 5.88916016,1.79980469 5.88916016,2.45849609 C5.88916016,2.77392578 6.01904297,3.12646484 6.28808594,3.46972656 C6.76123047,4.07275391 7.83740234,4.93554687 9.24755859,5.73339844 L8.95068359,10.09375 C6.31591797,11.0771484 4.7109375,13.1181641 4.7109375,15.1499023 Z"
                id="Path"
                fill="url(#linearGradient-pin)"
                fillRule="nonzero"
            ></path>
        </g>
    </svg>
)

export const FxGradientIcon = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>icons/layer_editor/motionfx</title>
        <defs>
            <linearGradient x1="2.31337923%" y1="100%" x2="97.6866208%" y2="1.53787854%" id="linearGradient-fx">
                <stop stopColor="#6157FF" offset="0%"></stop>
                <stop stopColor="#E646B6" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="icons/layer_editor/motionfx" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M13.5032404,4.79688561 C13.7083083,4.79688561 13.8817029,4.72602507 14.0234239,4.58430398 C14.165145,4.44258289 14.2360056,4.26609592 14.2360056,4.05484307 C14.2360056,3.84977512 14.165145,3.6777577 14.0234239,3.53879082 C13.8817029,3.39982395 13.7083083,3.33034051 13.5032404,3.33034051 L7.08650759,3.33034051 L8.54290561,4.79688561 L13.5032404,4.79688561 Z M15.9894235,7.32597649 C16.1944915,7.32597649 16.3692873,7.25526091 16.5138109,7.11382973 C16.6583345,6.97239856 16.7305963,6.79605655 16.7305963,6.5848037 C16.7305963,6.37973575 16.6583345,6.20771833 16.5138109,6.06875146 C16.3692873,5.92978458 16.1944915,5.86030114 15.9894235,5.86030114 L9.56442813,5.86030114 L11.0124185,7.32597649 L15.9894235,7.32597649 Z M18.4347284,9.85593713 C18.6403762,9.85593713 18.815317,9.78493162 18.9595507,9.64292062 C19.1037844,9.50090961 19.1759012,9.32485752 19.1759012,9.11476433 C19.1759012,8.90901991 19.1037844,8.73668842 18.9595507,8.59776986 C18.815317,8.4588513 18.6403762,8.38939202 18.4347284,8.38939202 L12.0432184,8.38939202 L13.5004862,9.85593713 L18.4347284,9.85593713 Z M20.916128,10.9193527 L14.520994,10.9193527 C14.7887806,11.1888788 14.9848129,11.4293166 15.1090906,11.6406661 C15.2333684,11.8520156 15.3032867,12.1001362 15.3188455,12.385028 L20.916128,12.385028 C21.1206161,12.385028 21.2938898,12.3129112 21.4359491,12.1686775 C21.5780084,12.0244437 21.6490381,11.849503 21.6490381,11.6438552 C21.6490381,11.4381108 21.5780084,11.2659243 21.4359491,11.1272956 C21.2938898,10.988667 21.1206161,10.9193527 20.916128,10.9193527 Z M12.7358301,19.5826522 L9.52152041,12.0984451 L9.01981906,13.0080596 L13.4888895,13.2591277 C13.7041045,13.2726572 13.8741409,13.2186843 13.9989984,13.0972091 C14.123856,12.9757339 14.1896913,12.8257502 14.1965044,12.6472579 C14.2033174,12.4687657 14.129606,12.3026916 13.9753702,12.1490356 L5.22161654,3.21654809 C5.08593539,3.07535851 4.93406721,3.0032175 4.76601199,3 C4.59795677,2.9970326 4.45333651,3.0512954 4.33215121,3.16291344 C4.21096591,3.27453149 4.15008334,3.43113498 4.14950351,3.63272393 L4.00048617,16.0653793 C3.99372144,16.2874557 4.0575515,16.4593765 4.19197634,16.5811416 C4.32640119,16.7029067 4.48457507,16.7620981 4.66649798,16.7587158 C4.84842089,16.7553334 5.01031537,16.6697596 5.15218142,16.5019943 L8.03076724,13.310443 L7.01460818,13.0040008 L10.1187494,20.6657821 C10.1839807,20.8431147 10.2926996,20.962947 10.444906,21.0252792 C10.5971125,21.0876113 10.7510584,21.0876596 10.9067438,21.0254241 L12.4440287,20.4002181 C12.6072519,20.3368229 12.7145454,20.227041 12.765909,20.0708724 C12.8172726,19.9147038 12.8072463,19.7519637 12.7358301,19.5826522 Z"
                id="Shape"
                fill="url(#linearGradient-pin)"
                fillRule="nonzero"
            ></path>
        </g>
    </svg>
)
